import { css } from '@emotion/react';
import { useTranslation } from '~/_shared/utils/hooks';
import { ZoomToLocationComponent } from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/zoomToLocation.component';

const allBoundariesHiddenWrapperStyle = css({
  margin: 0,
  padding: 10,
});

type ZoomToLocationOrHiddenMessageProps = Readonly<{
  allBoundariesHidden: boolean;
  targetZoomLevel?: number;
  isLoading: boolean;
}>;

export const ZoomToLocationOrHiddenMessageComponent = ({
  allBoundariesHidden,
  targetZoomLevel,
  isLoading,
}: ZoomToLocationOrHiddenMessageProps) => {
  const [t] = useTranslation();

  if (allBoundariesHidden) {
    return (
      <p css={allBoundariesHiddenWrapperStyle}>
        {t('activeBoundary.allBoundariesHidden')}
      </p>
    );
  }

  return (
    <ZoomToLocationComponent
      targetZoomLevel={targetZoomLevel}
      isLoading={isLoading}
    />
  );
};
